// Import the functions you need from the SDKs you need
import { getFirestore } from "firebase/firestore";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBbm_KikNr-OeOgnCI1q5suWoLFeB_n1iE",
  authDomain: "matches-pro.firebaseapp.com",
  projectId: "matches-pro",
  storageBucket: "matches-pro.firebasestorage.app",
  messagingSenderId: "783412744107",
  appId: "1:783412744107:web:052a8db8524894b798ccee",
  measurementId: "G-4WBV6NQFXE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase
export const db = getFirestore(app);
// const analytics = getAnalytics(app);